export default "__VITE_ASSET__BeNQ83qV__"